<template>
  <div class="ele-body">
    <el-card shadow="never">
      <el-row :gutter="15">
        <el-col :md="6" style="margin-bottom: 15px">
          <!-- 操作按钮 -->
          <div class="ele-table-tool ele-table-tool-default">
            <el-button @click="showEditGroup = true" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small">添加 </el-button>
            <el-button @click="editGroup" type="warning" icon="el-icon-edit" class="ele-btn-icon" :disabled="!currentGroup" size="small"
              >修改
            </el-button>
            <el-button @click="removeGroup" type="danger" icon="el-icon-delete" class="ele-btn-icon" :disabled="!currentGroup" size="small"
              >删除
            </el-button>
            <el-button @click="openImport" type="primary" icon="el-icon-upload" class="ele-btn-icon export" :disabled="!currentGroup" size="small"
              >导入教师
            </el-button>
          </div>
          <!-- 数据表格 -->
          <ele-data-table
            ref="group"
            :config="group"
            :current.sync="currentGroup"
            @row-click="chooseGroup"
            @done="doneGroup"
            highlight-current-row
            :height="tbHeight"
            class="dict-table"
          >
            <el-table-column type="index" width="45" align="center" />
            <el-table-column prop="groupName" label="考勤组名称" show-overflow-tooltip>
              <template #default="{ row }">{{ row.groupName }}</template>
            </el-table-column>
          </ele-data-table>
        </el-col>
        <el-col :md="18" style="margin-bottom: 15px">
          <!-- 搜索表单 -->
          <el-form label-width="77px" class="ele-form-search">
            <el-row :gutter="15">
              <el-col :md="6" :sm="12">
                <el-form-item label="日期:">
                  <el-date-picker v-model="date" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" />
                </el-form-item>
              </el-col>
              <el-col :md="6" :sm="12">
                <el-form-item label="教师姓名:">
                  <el-input v-model.trim="teacherName" placeholder="请输入姓名" clearable />
                </el-form-item>
              </el-col>
              <el-col :md="6" :sm="12">
                <div class="ele-form-actions">
                  <el-button
                    type="primary"
                    icon="el-icon-search"
                    class="ele-btn-icon"
                    @click="queryTeacherAttendance(currentGroup.id, date, teacherName)"
                    >查询</el-button
                  >
                </div>
              </el-col>
            </el-row>
          </el-form>
          <!-- 操作按钮 -->
          <div class="ele-table-tool ele-table-tool-default">
            <el-button @click="showAttendanceList" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small">设置考勤时间</el-button>
            <el-button @click="openExport" type="primary" icon="el-icon-download" class="ele-btn-icon" size="small">导出</el-button>
            <el-button @click="openAttendancePeople" type="primary" icon="el-icon-s-tools" class="ele-btn-icon" size="small"
              >设置考勤人员变动</el-button
            >
          </div>
          <!-- 数据表格 -->
          <ele-data-table ref="table" :config="table" :data="attendanceData" :choose.sync="choose" @cell-click="takeClock" highlight-current-row>
            <template>
              <el-table-column v-for="(item, index) in teacherAttendanceNameList" :key="index" :label="item">
                <template #default="{ row }">
                  <span v-if="item == '姓名' || item == '手机号' || item == '教师Id'">{{ row[item] }}</span>
                  <el-tag v-else effect="dark" :type="row[item] == null ? 'danger' : 'success'">{{
                    row[item] == null ? '未打卡' : row[item]
                  }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="200px" align="center" :resizable="false">
                <template #default="{ row }">
                  <el-popconfirm title="确定要删除此教师吗？" @onConfirm="removeTeacher(row)" class="ele-action">
                    <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false">删除</el-link>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </template>
          </ele-data-table>
        </el-col>
      </el-row>
    </el-card>
    <!-- 编辑弹窗 -->
    <el-dialog
      :title="groupForm.id ? '修改考勤组' : '添加考勤组'"
      :visible.sync="showEditGroup"
      width="400px"
      @closed="groupForm = {}"
      :destroy-on-close="true"
      :lock-scroll="false"
    >
      <el-form :model="groupForm" ref="groupForm" :rules="groupRules" label-width="100px">
        <el-form-item label="考勤组名称:" prop="groupName">
          <el-input v-model="groupForm.groupName" placeholder="请输入考勤组名称" clearable />
        </el-form-item>
        <el-form-item label="负责人:" prop="principal">
          <treeselect
            v-model="groupForm.principal"
            :options="deptTeacher"
            :disable-branch-nodes="true"
            :multiple="true"
            placeholder="请选择老师"
            :defaultExpandLevel="2"
            search-nested
            noChildrenText="该部门无人员"
            :normalizer="
              (d) => {
                return { id: d.id, label: d.name };
              }
            "
            style="line-height: 20px"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showEditGroup = false">取消</el-button>
        <el-button type="primary" @click="saveGroup(groupForm.id)">保存</el-button>
      </div>
    </el-dialog>
    <!--考勤组教师导入弹窗-->
    <el-dialog
      title="考勤组教师导入"
      :visible.sync="showImportTeacher"
      width="440px"
      :destroy-on-close="true"
      :lock-scroll="false"
      :close-on-click-modal="false"
    >
      <el-upload
        v-loading="uploadLoading"
        :action="$http.defaults.baseURL + '/hwTeacherAttendance/importTeacherByAttendanceGroup'"
        accept=".xls,.xlsx"
        :headers="$http.defaults.headers.common"
        :data="fileParam"
        :before-upload="() => (uploadLoading = true)"
        class="ele-block"
        :on-success="uploadGroupTeacherSuccess"
        :on-error="() => (uploadLoading = false)"
        :show-file-list="false"
        drag
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或 <em>点击上传</em></div>
        <div class="el-upload__tip ele-text-center" slot="tip">
          只能上传xls、xlsx文件，
          <el-link type="primary" :underline="false" :href="templeta" download style="vertical-align: baseline">下载模板 </el-link>
        </div>
      </el-upload>
    </el-dialog>
    <!--设置考勤时间弹窗-->
    <el-dialog
      title="考勤时间设置"
      :visible.sync="showSetTeacherAttendance"
      width="800px"
      @closed="attendanceListForm = {}"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
      :lock-scroll="false"
    >
      <ele-data-table ref="attendanceListTable" :data="attendanceListData" border :config="attendanceListTable" highlight-current-row>
        <el-table-column type="index" width="45" align="center" />
        <el-table-column label="名称" prop="attendanceName" show-overflow-tooltip>
          <template #default="{ row, $index }">
            <el-input v-if="$index === editIndex" v-model="attendanceListForm.attendanceName" placeholder="请输入名称" style="width: 95%" />
            <span v-else>{{ row.attendanceName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="开始时间" prop="beginTime" show-overflow-tooltip>
          <template #default="{ row, $index }">
            <el-time-picker
              v-if="$index === editIndex"
              v-model="attendanceListForm.beginTime"
              placeholder="选择开始时间"
              value-format="HH:mm"
              format="HH:mm"
              style="width: 95%"
            />
            <span v-else>{{ row.beginTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="结束时间" prop="endTime" show-overflow-tooltip>
          <template #default="{ row, $index }">
            <el-time-picker
              v-if="$index === editIndex"
              v-model="attendanceListForm.endTime"
              placeholder="选择结束时间"
              value-format="HH:mm"
              format="HH:mm"
              style="width: 95%"
            />
            <span v-else>{{ row.endTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150px" align="center" :resizable="false">
          <template #default="{ row, $index }">
            <div v-if="$index === editIndex">
              <el-link @click="onSaveattendance(row, $index)" icon="el-icon-check" type="success" :underline="false">保存 </el-link>
              <el-link @click="onCancelattendance(row, $index)" icon="el-icon-close" type="warning" :underline="false">取消 </el-link>
            </div>
            <div v-else>
              <el-link @click="onEditattendance(row, $index)" icon="el-icon-edit" type="primary" :underline="false">修改 </el-link>
              <span class="ele-action">
                <el-popconfirm title="确定要删除此考勤时间吗？" @onConfirm="onRemoveattendance(row, $index)">
                  <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false">删除</el-link>
                </el-popconfirm>
              </span>
            </div>
          </template>
        </el-table-column>
      </ele-data-table>
      <el-button @click="addAttendance" icon="el-icon-plus" style="width: 100%; margin-top: 15px">新增考勤时间</el-button>
      <span slot="footer" class="dialog-footer">
        <el-button @click="beforeClose">取 消</el-button>
        <el-button type="primary" @click="beforeClose">确 定</el-button>
      </span>
    </el-dialog>
    <!--导出弹窗设置时间-->
    <el-dialog
      title="导出"
      :visible.sync="showExport"
      width="400px"
      @closed="exportForm = {}"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
      :lock-scroll="false"
    >
      <el-form ref="exportForm" :model="exportForm" label-width="80px" :rules="exportRules">
        <el-form-item label="开始时间" prop="startTime">
          <el-date-picker v-model="exportForm.startTime" type="date" placeholder="选择开始日期" style="width: 80%" />
        </el-form-item>
        <el-form-item label="结束时间" prop="endTime">
          <el-date-picker v-model="exportForm.endTime" type="date" placeholder="选择结束日期" style="width: 80%" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showExport = false">取 消</el-button>
        <el-button type="primary" @click="exportData">确 定</el-button>
      </span>
    </el-dialog>
    <!--设置人员变动弹窗-->
    <el-dialog title="提示" :visible.sync="showSetPeople" width="30%" :destroy-on-close="true" :lock-scroll="false" :close-on-click-modal="false">
      <el-form ref="form" label-width="80px">
        <el-form-item label="老师:">
          <treeselect
            v-model="teacherIds"
            :options="deptTeacher"
            :disable-branch-nodes="true"
            :multiple="true"
            placeholder="请选择老师"
            :defaultExpandLevel="2"
            search-nested
            noChildrenText="该部门无人员"
            :normalizer="
              (d) => {
                return { id: d.id, label: d.name };
              }
            "
            style="line-height: 20px"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showSetPeople = false">取 消</el-button>
        <el-button type="primary" @click="setAttendancePeople">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import Treeselect from '@riophae/vue-treeselect'; // 下拉树
  import '@riophae/vue-treeselect/dist/vue-treeselect.css';
  import {
    addTeacherAttendanceGroup,
    getAllDepartTeachers,
    updateTeacherAttendanceGroup,
    deleteTeacherAttendanceGroup,
    getTeacherAttendanceRecordByAttendanceGroup,
    getTeacherAttendanceListByGroup,
    setTeacherAttendanceByGroup,
    updateTeacherAttendance,
    deleteTeacherAttendance,
    exportTeacherAttendanceRecordByAttendanceGroup,
    addTeacherAttendanceSlotFace,
    delTeacherByAttendanceGroup,
    findTeacherByAttendanceId,
    addTeacherByAttendanceGroup,
  } from '@/config/api';

  export default {
    name: 'TeacherTotal1',
    components: { Treeselect },
    data() {
      return {
        group: {
          // 表格配置
          url: '/hwTeacherAttendance/getTeacherAttendanceGroupList',
          page: false,
          where: {},
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            return res;
          },
        },
        currentGroup: null, // 表格选中数据
        showEditGroup: false, // 是否显示表单弹窗
        groupForm: {}, // 表单数据
        groupRules: {
          // 表单验证规则
          groupName: [{ required: true, message: '请输入考勤组名称', trigger: 'blur' }],
          principal: [{ required: true, message: '请选择负责人', trigger: 'change' }],
        },
        deptTeacher: [], //部门下老师数据
        table: {
          page: {
            page: 1,
            limit: 10,
          },
        },
        choose: [], // 表格选中数据
        attendanceData: [], //统计数据
        teacherAttendanceNameList: [], //表头数据
        showImportTeacher: false,
        uploadLoading: false,
        fileParam: {
          groupId: null,
        },
        templeta: 'https://hdsys.oss-cn-beijing.aliyuncs.com/hdjxt/template/1631176262979/考勤组教师信息.xlsx', //模板链接
        date: this.$util.toDateString(new Date(), 'yyyy-MM-dd'),
        showExport: false,
        exportForm: {
          startTime: null,
          endTime: null,
        },
        exportRules: {
          startTime: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
          endTime: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
        },
        showSetTeacherAttendance: false, //设置考勤时间弹窗
        attendanceListTable: {
          page: false,
        },
        attendanceListData: [],
        attendanceListForm: {
          attendanceName: '',
          beginTime: null,
          endTime: null,
        },
        editIndex: null,
        editType: 1,
        authType: 1, //查看权限
        groupId: null,
        showSetPeople: false, //人员变动弹窗
        teacherIds: [],
        teacherName: '',
      };
    },
    computed: {
      /* 表格固定高度 */
      tbHeight() {
        return this.$store.state.theme.screenWidth < 992 ? undefined : 'calc(100vh - 214px)';
      },
    },
    mounted() {
      this.querydeptTeacher(); //部门下的所有老师数据
    },
    methods: {
      /* 获取所有部门下的所有老师 树 */
      querydeptTeacher() {
        getAllDepartTeachers().then((res) => {
          if (res.data.resCode == 200) {
            this.deptTeacher = res.data.data;
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      /* 表格渲染完成回调 */
      doneGroup(res) {
        console.log(res);
        if (res.data.length > 0) {
          this.$refs.group.setCurrentRow(res.data[0]);
          this.chooseGroup(res.data[0]);
        }
      },
      /* 显示编辑 */
      editGroup() {
        this.groupForm = Object.assign({}, this.currentGroup);
        this.groupForm.principal = this.currentGroup.principal.split(',').map((item) => {
          return +item;
        });
        this.showEditGroup = true;
      },
      /* 保存考勤组 */
      saveGroup(id) {
        this.$refs['groupForm'].validate((valid) => {
          if (valid) {
            const loading = this.$loading({ lock: true });
            // this.groupForm.principal = this.groupForm.principalIds.toString();
            // this.groupForm.principal = this.groupForm.principal.split(',')
            let formData = new FormData();
            for (let key in this.groupForm) {
              if (this.groupForm[key] !== null && this.groupForm[key] !== undefined) {
                formData.append(key, this.groupForm[key]);
              }
            }
            if (id === undefined) {
              addTeacherAttendanceGroup(formData).then((res) => {
                loading.close();
                if (res.data.resCode == 200) {
                  this.showEditGroup = false;
                  this.$message({ type: 'success', message: res.data.resMsg });
                  this.$refs.group.reload();
                } else {
                  this.$message.error(res.data.resMsg);
                }
              });
            } else {
              updateTeacherAttendanceGroup(formData).then((res) => {
                loading.close();
                if (res.data.resCode == 200) {
                  this.showEditGroup = false;
                  this.$message({ type: 'success', message: res.data.resMsg });
                  this.$refs.group.reload();
                } else {
                  this.$message.error(res.data.resMsg);
                }
              });
            }
          } else {
            return false;
          }
        });
      },
      /* 删除考勤组 */
      removeGroup() {
        this.$confirm('确定要删除选中的考勤组吗?', '提示', {
          type: 'warning',
        }).then(() => {
          const loading = this.$loading({ lock: true });
          let formData = new FormData();
          formData.append('id', this.currentGroup.id);
          deleteTeacherAttendanceGroup(formData).then((res) => {
            loading.close();
            if (res.data.resCode == 200) {
              this.showEdit = false;
              this.$message({ type: 'success', message: res.data.resMsg });
              this.$refs.group.reload();
            } else {
              this.$message.error(res.data.resMsg);
            }
          });
        });
      },
      /* 打开教师导入弹窗并传入参数 */
      openImport() {
        this.fileParam.groupId = this.currentGroup.id;
        this.showImportTeacher = true;
      },
      /* 导入教师成功 */
      uploadGroupTeacherSuccess(res) {
        this.uploadLoading = false;
        if (res.resCode == '200') {
          this.showImportTeacher = false;
          this.$message({ type: 'success', message: res.resMsg });
        } else if (res.resCode == '5001') {
          const url = res.resMsg;
          this.$confirm('是否下载本次导入失败的记录', '温馨提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              window.open(url);
              this.showImportTeacher = false;
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '下载失败',
              });
              this.showImportTeacher = false;
            });
        } else {
          this.$message.error(res.resMsg);
        }
      },
      // 选择考勤组时获取教师考勤表
      chooseGroup(row, column, event) {
        console.log(column, event);
        this.groupId = row.id;
        this.queryTeacherAttendance(row.id, this.date, this.teacherName);
      },
      // 查询考勤统计
      queryTeacherAttendance(groupId, date, teacherName) {
        let data = {
          date: date,
          groupId: groupId,
          teacherName: teacherName,
        };
        getTeacherAttendanceRecordByAttendanceGroup(data).then((res) => {
          if (res.data.resCode == 200) {
            this.attendanceData = res.data.data.records;
            this.teacherAttendanceNameList = res.data.data.teacherAttendanceNameList;
            this.authType = 1; //有权限查看
          } else if (res.data.resCode == 500) {
            this.teacherAttendanceNameList = [];
            this.attendanceData = [];
            this.authType = 2; //无权限查看
            this.$message.error(res.data.resMsg);
          }
        });
      },
      // 打开弹窗并且获取考勤内容数据
      showAttendanceList() {
        let data = {
          groupId: this.currentGroup.id,
        };
        this.showSetTeacherAttendance = true;
        getTeacherAttendanceListByGroup(data).then((res) => {
          if (res.data.resCode == 200) {
            this.attendanceListData = res.data.data;
          }
        });
      },
      // 新增考勤时间
      addAttendance() {
        this.editType = 1;
        if (this.attendanceListData.length == 0) {
          this.attendanceListData.push({ __is_add: true });
          this.attendanceListForm = {
            attendanceName: '',
            beginTime: null,
            endTime: null,
          };
          this.editIndex = 0;
        }
        if (this.attendanceListData[this.attendanceListData.length - 1].__is_add) return;
        this.attendanceListData.push({ __is_add: true });
        this.attendanceListForm = {
          attendanceName: '',
          beginTime: null,
          endTime: null,
        };
        this.editIndex = this.attendanceListData.length - 1;
      },
      // 保存编辑
      onSaveattendance(row, index) {
        if (!this.attendanceListForm.attendanceName) return this.$message.error('请输入名称');
        if (!this.attendanceListForm.beginTime) return this.$message.error('请选择开始时间');
        if (!this.attendanceListForm.endTime) return this.$message.error('请选择结束时间');
        let data = new FormData();
        for (let key in this.attendanceListForm) {
          if (this.attendanceListForm[key] !== null && this.attendanceListForm[key] !== undefined) {
            data.append(key, this.attendanceListForm[key]);
          }
        }
        if (this.editType == 1) {
          //添加
          data.append('groupId', this.currentGroup.id);
          setTeacherAttendanceByGroup(data).then((res) => {
            if (res.data.resCode == 200) {
              this.$message({ type: 'success', message: res.data.resMsg });
              this.showAttendanceList();
              this.attendanceListData[index] = Object.assign({}, this.attendanceListForm, { __is_add: false });
              this.editIndex = null;
              this.attendanceListForm = {};
              this.queryTeacherAttendance(this.currentGroup.id, this.date, this.teacherName);
            } else {
              this.$message.error(res.data.resMsg);
            }
          });
        } else {
          //修改
          updateTeacherAttendance(data).then((res) => {
            if (res.data.resCode == 200) {
              this.$message({ type: 'success', message: res.data.resMsg });
              this.attendanceListData[index] = Object.assign({}, this.attendanceListForm, { __is_add: false });
              this.showAttendanceList();
              this.editIndex = null;
              this.attendanceListForm = {};
              this.queryTeacherAttendance(this.currentGroup.id, this.date, this.teacherName);
            } else {
              this.$message.error(res.data.resMsg);
            }
          });
        }
      },
      // 取消编辑
      onCancelattendance(row, index) {
        if (row.__is_add) this.attendanceListData.splice(index, 1);
        this.editIndex = null;
        this.attendanceListForm = {};
      },
      // 修改行
      onEditattendance(row, index) {
        this.editType = 2;
        this.editIndex = index;
        this.attendanceListForm = Object.assign({}, row);
      },
      /* 删除行 */
      onRemoveattendance(row, index) {
        this.attendanceListData.splice(index, 1);
        let data = new FormData();
        data.append('id', row.id);
        deleteTeacherAttendance(data).then((res) => {
          if (res.data.resCode == 200) {
            this.$message({ type: 'success', message: '已删除' });
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      // 考勤内容设置弹窗 关闭前
      beforeClose() {
        if (this.editIndex != null) {
          this.$message.error('请先保存数据！');
        } else {
          this.showSetTeacherAttendance = false;
          this.queryTeacherAttendance(this.currentGroup.id, this.date, this.teacherName);
        }
      },
      // 打开导出弹框前判断
      openExport() {
        if (this.authType === 1) {
          this.showExport = true;
        } else {
          this.$message.error('你不是该考勤组负责人，无法导出考勤统计！');
          return false;
        }
      },
      // 导出数据
      exportData() {
        this.$refs['exportForm'].validate((valid) => {
          if (valid) {
            let data = {
              groupId: this.currentGroup.id,
              startTime: this.$util.toDateString(this.exportForm.startTime, 'yyyy-MM-dd'),
              endTime: this.$util.toDateString(this.exportForm.endTime, 'yyyy-MM-dd'),
            };
            exportTeacherAttendanceRecordByAttendanceGroup(data).then((res) => {
              let blob = new Blob([res.data], {
                type: 'application/octet-stream',
              });
              let objectUrl = URL.createObjectURL(blob);
              let link = document.createElement('a');
              link.style.display = 'none';
              link.href = objectUrl;
              let filename = window.decodeURI(res.headers['content-disposition'].split('=')[1], 'UTF-8');
              link.setAttribute('download', filename);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link); // 下载完成移除元素
              window.URL.revokeObjectURL(objectUrl); // 释放掉blob对象
            });
            this.showExport = false;
          }
        });
      },
      // 手动打卡
      takeClock(row, column, cell, event) {
        // console.log(row, column, cell, event);
        // console.log(cell.innerText);
        // console.log(column.label);
        // console.log(event.path[0].innerText);
        if (cell.innerText === '未打卡') {
          this.$confirm('该教师没有打卡，确定要手动打卡吗?', '提示', {
            type: 'warning',
          })
            .then(() => {
              let data = new FormData();
              data.append('attendanceName', column.label);
              data.append('date', this.date);
              data.append('groupId', this.currentGroup.id);
              data.append('mobile', row.手机号);
              addTeacherAttendanceSlotFace(data).then((res) => {
                if (res.data.resCode == 200) {
                  this.$message.success('打卡成功！');
                  this.queryTeacherAttendance(this.currentGroup.id, this.date, this.teacherName);
                } else {
                  this.$message.error('手动打卡失败');
                  console.log(res.data.resMsg);
                }
              });
            })
            .catch(() => {});
        }
      },
      // 删除教师
      removeTeacher(row) {
        let teacherIds = [];
        teacherIds.push(row.教师Id);
        let formData = new FormData();
        formData.append('groupId', this.currentGroup.id);
        formData.append('teacherIds', teacherIds);
        delTeacherByAttendanceGroup(formData).then((res) => {
          if (res.data.resCode == 200) {
            this.$message({ type: 'success', message: '已删除' });
            this.queryTeacherAttendance(this.currentGroup.id, this.date, this.teacherName);
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      // 获取考勤组下的老师id
      openAttendancePeople() {
        findTeacherByAttendanceId({ groupId: this.groupId }).then((res) => {
          if (res.data.resCode == 200) {
            this.teacherIds = res.data.data;
            this.showSetPeople = true;
          }
        });
      },
      // 添加教师
      setAttendancePeople() {
        let data = new FormData();
        data.append('groupId', this.groupId);
        data.append('teacherIds', this.teacherIds);
        addTeacherByAttendanceGroup(data).then((res) => {
          if (res.data.resCode == 200) {
            this.$message({ type: 'success', message: res.data.resMsg });
            this.queryTeacherAttendance(this.currentGroup.id, this.date, this.teacherName);
            this.showSetPeople = false;
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
    },
  };
</script>

<style scoped>
  .dict-table >>> .el-table__row {
    cursor: pointer;
  }

  .dict-table >>> .el-table__row > td:last-child:after {
    content: '\e6e0';
    font-family: element-icons !important;
    font-style: normal;
    font-variant: normal;
    text-transform: none;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    line-height: 1;
    position: absolute;
    right: 10px;
    top: 50%;
    margin-top: -7px;
  }

  .dict-table >>> .el-table__row > td:last-child .cell {
    padding-right: 20px;
  }
  .ele-block {
    display: flex !important;
    flex-flow: column !important;
    align-items: center !important;
  }
  .ele-table-tool {
    flex-wrap: wrap;
  }
  /deep/ .el-table__empty-block {
    width: 100% !important;
  }

  @media only screen and (max-width: 1440px) {
    .export {
      margin-top: 5px;
      margin-left: 0;
    }
  }
</style>
